<template>
    <div class="content">
        <div class="welcome">
            <div class="weUser">
                {{ userName }}，{{$t('meg.welcome')}}
            </div>
            <div style="display: flex;">
                <p class="warn">{{$t('meg.carefully')}}</p>
                <el-button class="xiadanBtn" @click="placeOrder" v-if="roleType == 1">{{$t('meg.start')}}</el-button>
                <el-button class="xiadanBtn" @click="orderList" v-if="roleType == 2">{{$t('meg.orderList')}}</el-button>
            </div>
        </div>
        <div class="secondBox">
            <div class="information">
                <h1 class="title">{{$t('meg.Basic')}}</h1>
                <hr style="margin-left: 31px;margin-right: 24px;margin-top: 19px;">
                <div class="informain">
                    <p>{{$t('meg.companyName')}}:<span style="margin-left: 20px;"> {{
                        roleType == 1
                        ? clientData.companyName
                        : roleType == 2
                            ? clientData.plantName
                            : ""
                    }}</span> </p>
                    <p>{{$t('meg.country')}}:<span style="margin-left: 20px;">{{ !clientData.affiliatingArea ? "" :
                        clientData.affiliatingArea }}</span></p>
                    <p>{{$t('meg.companyWebsite')}}:<span style="margin-left: 20px;">{{
                        roleType == 1
                        ? clientData.companyUrl
                        : roleType == 2
                            ? clientData.plantUrl
                            : ""
                    }}</span></p>
                    <p>{{$t('meg.companyAddress')}}:<span style="margin-left: 20px;">{{
                        roleType == 1
                        ? clientData.companyAddress
                        : roleType == 2
                            ? clientData.plantAddress
                            : ""
                    }}</span></p>
                </div>
            </div>
            <div class="message">
                <h1 class="title">
                    <img src="../../assets/img/icon_message.png" alt="" style="width: 22px;height: 22px;margin-right: 6px">
                    消息通知
                </h1>
                <hr style="margin-left: 31px;margin-right: 24px;margin-top: 19px;">
                <div style="display: flex;justify-content: space-between;">
                    <div style="margin-left: 30px;text-align: left;margin-top: 19px;">
                        <p style="font-size: 16px;font-family: PingFang SC, PingFang SC;font-weight: bold;color:#333333;">
                            审核通知</p>
                        <p
                            style="font-size: 16px;font-family: PingFang SC, PingFang SC;font: 1em sans-serif;ont-weight: 500;color: #333333;margin-top: 11px;">
                            您提交的订单审核通过，等待生产商接单中。</p>

                    </div>

                    <div
                        style="font-size: 14px;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #A2A2A2;margin-top: 23px;margin-right: 24px">
                        2023年11月08日 23:01</div>
                </div>
                <hr style="margin-left: 31px;margin-right: 24px;margin-top: 24px;">
                <div style="display: flex;justify-content: space-between;">
                    <div style="margin-left: 30px;text-align: left;margin-top: 19px;">
                        <p style="font-size: 16px;font-family: PingFang SC, PingFang SC;font-weight: bold;color:#333333;">
                            审核通知</p>
                        <p
                            style="font-size: 16px;font-family: PingFang SC, PingFang SC;font: 1em sans-serif;ont-weight: 500;color: #333333;margin-top: 11px;">
                            您提交的订单审核通过，等待生产商接单中。</p>

                    </div>

                    <div
                        style="font-size: 14px;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #A2A2A2;margin-top: 23px;margin-right: 24px">
                        2023年11月08日 23:01</div>
                </div>
                <!-- <hr style="margin-left: 31px;margin-right: 24px;margin-top: 24px;"> -->
                <p
                    style="font-size: 14px;font-family: PingFang SC, PingFang SC;font-weight: bold;color: #002FA7;margin-top: 43px;">
                    查看全部》</p>
            </div>
        </div>
        <div class="order" style="overflow:hidden ;">
            <h1 class="title">{{$t('meg.allorder')}}</h1>
            <hr style="margin-left: 31px;margin-right: 24px;margin-top: 19px;">
            <div style="margin-left: 31px;margin-top: 24px;">
                <ul class="status" style="display: flex;gap: 84px;">
                    <li :class="{ active: orderStatus === '' }" @click="changeTab('')">{{$t('meg.all')}}</li>
                    <li :class="{ active: orderStatus === 1 }" @click="changeTab(1)">{{$t('meg.pendOrder')}}</li>
                    <li :class="{ active: orderStatus === 2 }" @click="changeTab(2)">{{$t('meg.produced')}}</li>
                    <li :class="{ active: orderStatus === 3 }" @click="changeTab(3)">{{$t('meg.received')}}</li>
                    <li :class="{ active: orderStatus === 4 }" @click="changeTab(4)">{{$t('meg.evaluated')}}</li>
                    <li :class="{ active: orderStatus === 5 }" @click="changeTab(5)">{{$t('meg.Completed')}}</li>
                </ul>
            </div>
            <div style="margin-top: 35px;margin-left: 31px;margin-right: 24px;">
                <el-table :data="tableData" style="width: 100%"
                    :header-cell-style="{ 'background': '#F7F9FD !important', 'color': '#333', 'height': '56px !important' }">
                    <el-table-column type="index" label="序号" width="180" />
                    <el-table-column prop="orderNumber" label="订单号" width="260px" />
                    <el-table-column prop="createTime" label="订单开始时间" />
                    <el-table-column prop="deliveryTime" label="订单交付时间" />
                    <el-table-column prop="orderState" label="状态" />
                    <el-table-column label="操作">
                        <template #default="scope">
                            <el-button link type="primary" size="small" class="caozuoBtn"
                                @click="handleClick(scope.row.orderId)" v-if="orderStatus !== 5">查看进度</el-button>
                            <el-button link type="primary" size="small" class="caozuoBtn" v-if="orderStatus == 3"
                                @click="clintBtn(scope.row.orderId)">确认收货</el-button>
                            <el-button link type="primary" size="small" class="caozuoBtn" v-if="orderStatus == 4"
                                @click="evaluteBtn(scope.row.orderId)">去评价</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <el-dialog v-model="dialogVisible" title="评价" width="30%" :before-close="handleClose" style="text-align: left;">
            <div>
                <span class="demonstration"
                    style="font-size: 16px;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #333333;">请您对本次订单进行评价</span>
                <el-rate v-model="remark" style="vertical-align: sub;margin-left: 37px;" />
            </div>
            <div style="display: flex;margin-top: 30px;">
                <span class="demonstration"
                    style="font-size: 16px;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #333333;width: 10%;">备注</span>
                <el-input v-model="Evaluate" type="textarea" />
            </div>
            <template #footer>
                <span class="dialog-footer">
                    <el-button style="width: 93px;height: 38px;" @click="dialogVisible = false">取消</el-button>
                    <el-button style="width: 93px;height: 38px;" type="primary" @click="evaluteQR()">
                        确认
                    </el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { orderData, selectClientByUserName, plantOrderData, selectPlantByUserName } from "@/api/mange.js"
import { getDicts, clintHarvest, orderEvaluation,selectIsInfo,mangeInfo } from "@/api/order.js"
import { onMounted, ref } from "vue"
import { useRouter, useRoute } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus'

const router = useRouter()
const orderStatus = ref("")
const tableData = ref([])
const stateData = ref([])
const clientData = ref({})
const dialogVisible = ref(false)
const roleType = ref("")
const route = useRoute()
const remark = ref("")
const Evaluate = ref("")
const idOrder = ref("")
const userName = ref(localStorage.getItem("userName"))
onMounted(() => {
    getDicts('order_state').then(res => {
        stateData.value = res.data.data
    })
    roleType.value = route.query.roleType
    if (roleType.value == 1) {
        getOrderList('')
        selectClient()
    } else if (roleType.value == 2) {
        plantData('')
        selectPlant()
    }
})
const changeTab = (index) => {
    orderStatus.value = index
    if (roleType.value == 1) {
        getOrderList(orderStatus.value)
    } else if (roleType.value == 2) {
        plantData(orderStatus.value)
    }
}
const getOrderList = (status) => {
    orderData({ orderState: status }).then(res => {
        tableData.value = []
        tableData.value = res.data.data
        stateData.value.map((item, index) => {
            tableData.value.map((val, index) => {
                if (val.orderState == item.dictValue) {
                    val.orderState = item.dictLabel
                }
            })
        })
    })
}

const plantData = (status) => {
    plantOrderData({ orderState: status }).then(res => {
        tableData.value = []
        tableData.value = res.data.data
        stateData.value.map((item, index) => {
            tableData.value.map((val, index) => {
                if (val.orderState == item.dictValue) {
                    val.orderState = item.dictLabel
                }
            })
        })
    })
}

const handleClick = (orderId) => {
    router.push({ path: '/orderdetails', query: { orderId: orderId } })

}


//确认收货
const clintBtn = (orderId) => {
    ElMessageBox.confirm(
        '是否确认已经收到货物？',
        '提示',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }
    ).then(() => {
        clintHarvest(orderId).then(res => {
            if (res.data.code == 200) {
                ElMessage.success("收货成功")
                if (roleType.value == 1) {
                    getOrderList(orderStatus.value)
                } else if (roleType.value == 2) {
                    plantData(orderStatus.value)
                }
            }
        })
    })
}

//待评价
const evaluteBtn = (orderId) => {
    dialogVisible.value = true
    idOrder.value = orderId
}


const evaluteQR = () => {
    let obj = {
        orderId: idOrder.value,
        remark: Evaluate.value,
        orderEvaluate: remark.value
    }
    orderEvaluation(obj).then(res => {
        if (res.data.code == 200) {
            ElMessage.success("评价成功")
            remark.value = ""
            Evaluate.value = ""
            dialogVisible.value = false
            if (roleType.value == 1) {
                getOrderList(orderStatus.value)
            } else if (roleType.value == 2) {
                plantData(orderStatus.value)
            }
        }
    })
}



//获取公司信息
const selectClient = () => {
    selectClientByUserName().then(res => {
        if (!clientData.value) {
            clientData.value = {}
        } else {
            clientData.value = res.data.data
        }
    })
}

//获取公司信息
const selectPlant = () => {
    selectPlantByUserName().then(res => {
        if (!clientData.value) {
            clientData.value = {}
        } else {
            clientData.value = res.data.data
        }
    })
}

//下单跳转页面
const placeOrder = () => {
    selectIsInfo().then(res => {
        if(res.data.code == 200) {
            router.push("/order")
        } else {
            ElMessage.error(res.data.msg)
        }
    })
    // router.push("/order")
}

const orderList = () => {
    mangeInfo().then(res => {
        if(res.data.code == 200) {
            router.push("/orderList")
        } else {
            ElMessage.error(res.data.msg)
        }
    })
}
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
}

.content {
    background: #F8F8F8;
    /* height: 995px; */
    overflow: hidden;
}

.welcome {
    margin: 23px 360px;
    height: 104px;
    background: #fff;
    border-radius: 10px 10px 10px 10px;
    display: flex;
    justify-content: space-between;
}

.weUser {
    font-size: 24px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    color: #333333;
    margin-top: 35px;
    margin-left: 31px;
}

.warn {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    color: #777777;
    margin-top: 42px;
    margin-right: 21px;
}

.xiadanBtn {
    width: 199px;
    height: 69px;
    background: #002FA7;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    font-size: 20px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    margin-top: 18px;
    margin-right: 20px;
}

.secondBox {
    margin: 14px 360px;
    height: 318px;
    /* background: #FFFFFF; */
    border-radius: 10px 10px 10px 10px;
    opacity: 1;
    display: flex;
}

.information {
    width: 645px;
    /* height: 318px; */
    background: #FFFFFF;
    margin-right: 19px;
    border-radius: 10px 10px 10px 10px;
}

.message {
    width: 538px;
    height: 318px;
    background: #FFFFFF;
}

.title {
    font-size: 20px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    color: #333333;
    text-align: left;
    margin-left: 31px;
    margin-top: 19px;
}

.informain {
    margin-top: 30px;
}

.informain p {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 14px;
    text-align: left;
    margin-left: 35px;
    margin-bottom: 30px;
}

.order {
    margin: 18px 360px;
    /* height: 367px; */
    background: #FFFFFF;
    border-radius: 10px 10px 10px 10px;
    opacity: 1;
    padding-bottom: 52px;
}

.status li {
    font-size: 16px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    color: #3C3C3C;
    padding-bottom: 11px;
    cursor: pointer;
}

.active {
    color: #002FA7 !important;
    border-bottom: 2px solid #002FA7;
}

.caozuoBtn {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    color: #002FA7;
}

::v-deep .el-table .cell {
    text-align: center;
}

::v-deep .el-textarea__inner {
    width: 437px;
    height: 154px !important;
}
</style>
